export default __webpack_public_path__ + "static/media/Template3.d3bcd454.png";